import {
	Box_t,
	SlipSheet_t,
	Pallet_t,
	LayoutTransform,
	SlipSheetConfig_t,
	Stack as StackObject,
} from 'blackbox';
import { UnitsSystem } from 'libapi';
import { ReactElement } from 'react';
import { KeyboardTrigger, SelectTrigger } from '../../Layout';

export enum StackStep {
	Summary,
	Create,
}

export type StackPath = [number, number];

export enum StackMode {
	Manual,
	Auto,
}

/**
 * Props for the stack summary/statistics view.
 */
export interface StackStatsProps {
	editingStack: StackObject;
	palletIndex: number;
	allBoxes: Box_t[];
	allSlipSheets: SlipSheet_t[];
	allPallets: Pallet_t[];
	unitsSystem: UnitsSystem;
	maxBoxes?: number;
}

/**
 * Wrapper used for rendering labeled options in AutoStack view.
 */
export interface AutoStackOptionProps {
	name: string;
	children: ReactElement;
}

/**
 * Parameters used for defining an auto-generated stack.
 */
export interface AutoStackParams {
	palletIndex: number;
	layoutIndex: number;
	layerCount: number;
	evenTransform: LayoutTransform.TransformType;
	oddTransform: LayoutTransform.TransformType;
	slipSheet: SlipSheetConfig_t;
}

/**
 * Props for the AutoStack configuration component.
 */
export interface AutoStackProps {
	allPallets: Pallet_t[];
	allSlipSheets: SlipSheet_t[];
	palletIndex: number;
	initialLayerCount: number;
	initialAutoStackParams: AutoStackParams | null;
	onAutoStackParamsChange: (params: AutoStackParams) => void;
	onKeyboardTrigger: KeyboardTrigger;
	onSelectTrigger: SelectTrigger;
	slipsheetEnabled: boolean;
}

/**
 * Props for the manual layer-by-layer stack editor.
 */
export interface ManualStackProps {
	palletIndex: number;
	allPallets: Pallet_t[];
	allSlipSheets: SlipSheet_t[];
	editingStack: StackObject;
	addLayer: () => void;
	removeLayer: (layerIndex: number) => void;
	setLayoutOnLayer: (layerIndex: number, layoutIndex: number) => void;
	setTransformOnLayer: (
		layerIndex: number,
		transform: LayoutTransform.TransformType
	) => void;
	setSlipSheetPresentOnLayer: (
		layerIndex: number,
		hasSlipSheet: boolean
	) => void;
	setSlipSheetTypeOnLayer: (layerIndex: number, slipSheetId: string) => void;
	updatePalletIndex: (index: number) => void;
	triggerSelect: SelectTrigger;
	slipsheetEnabled: boolean;
}

/**
 * Props for an individual cell in the stack matrix view.
 */
export interface StackCellProps {
	pallet: Pallet_t;
	palletIndex: number;
	stackIndex: number;
	unitsSystem: UnitsSystem;
	startEdit: () => void;
	deleteStack: (palletIndex: number, stackIndex: number) => void;
	duplicateStack: () => void;
	boxes?: Box_t[];
}

export interface TargetPalletProps {
	palletIndex: number;
	allPallets: Pallet_t[];
	selectTargetPallet: (pNewPalletIndex: number) => void;
	triggerSelect: SelectTrigger;
}